var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      {
        staticClass: "modal modal-fullscreen-xl",
        attrs: {
          id: "images-modal",
          tabindex: "-1",
          role: "dialog",
          "aria-hidden": "true",
        },
      },
      [
        _c(
          "div",
          { staticClass: "modal-dialog", attrs: { role: "document" } },
          [
            _c("div", { staticClass: "modal-content" }, [
              _c(
                "div",
                {
                  staticClass:
                    "modal-header detailphoto d-flex justify-content-start",
                },
                [
                  _vm._m(0),
                  _vm._v(" "),
                  _c("h5", { staticClass: "modal-title" }, [
                    _c(
                      "a",
                      {
                        attrs: {
                          "data-dismiss": "modal",
                          "aria-label": "Close",
                        },
                      },
                      [_vm._v(_vm._s(_vm.i18n.back_to_add))]
                    ),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "modal-body" },
                _vm._l(_vm.items, function (src) {
                  return _c("v-lazy-image", { attrs: { src: src } })
                }),
                1
              ),
            ]),
          ]
        ),
      ]
    ),
    _vm._v(" "),
    _c(
      "button",
      {
        staticClass: "btn btn-open-modal",
        attrs: { "data-toggle": "modal", "data-target": "#images-modal" },
      },
      [
        _c("i", { staticClass: "fas fa-expand mr-2" }),
        _vm._v(_vm._s(_vm.i18n.show_all) + "\n  "),
      ]
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "button",
      {
        staticClass: "close m-0 p-0",
        attrs: {
          type: "button",
          "data-dismiss": "modal",
          "aria-label": "Close",
        },
      },
      [
        _c("span", { attrs: { "aria-hidden": "true" } }, [
          _c("i", { staticClass: "fas fa-chevron-left pr-2" }),
        ]),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }